import Grid from "@mui/material/Grid";
import ValidatorSelectField from "../../FormFields/ValidatorSelectField";
import MenuItem from "@mui/material/MenuItem";
import EmailCheck from "../../EmailCheck/EmailCheck";
import ButtonLoading from "../../Button/ButtonLoading";
import ButtonTextTermsOfServicePrivacy from "../Common/ButtonTextTermsOfServicePrivacy/ButtonTextTermsOfServicePrivacy";
import React from "react";
import { useForm } from "../../../provider/Form/FormProvider";
import { dismissalCheckinStyle } from "./dismissalCheckinStyle";
import { emailDefault, isPhoneNumberDefault, minStringLength, requiredValidator } from "../../../services/validationRules";
import ValidatorTextField from "../../FormFields/ValidatorTextField";

type DismissalCheckinFormProps = {
  isLoading: boolean;
  emailErrorText: string;
  setEmailErrorText: (emailErrorText: string) => void;
  showPersonFields?: boolean;
};

export default function DismissalCheckinForm({ isLoading, emailErrorText, setEmailErrorText, showPersonFields = false }: DismissalCheckinFormProps) {
  const { handleSubmit } = useForm();
  return (
    <form onSubmit={handleSubmit}>
      <Grid container columnSpacing={4}>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: showPersonFields ? 6 : 4
          }}>
          <ValidatorSelectField
            label={"Anzahl Mitarbeiter im Unternehmen"}
            name={"numberOfEmployees"}
            validators={[requiredValidator("Bitte geben Sie an, wie viele Mitarbeiter in Ihrem Unternehmen beschäftigt sind.")]}
          >
            <MenuItem value={"10"}>0 - 10</MenuItem>
            <MenuItem value={"50"}>11 - 50</MenuItem>
            <MenuItem value={"500"}>51 - 500</MenuItem>
            <MenuItem value={"1000"}>Mehr als 500</MenuItem>
          </ValidatorSelectField>
        </Grid>
        {showPersonFields && (
          <>
            <Grid
              size={{
                xs: 12,
                sm: 6
              }}>
              <ValidatorSelectField label="Anrede" name={`gender`} validators={[requiredValidator("Bitte geben Sie Ihre Anrede an.")]} autoComplete="sex">
                <MenuItem value={"female"}>Frau</MenuItem>
                <MenuItem value={"male"}>Herr</MenuItem>
              </ValidatorSelectField>
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6
              }}>
              <ValidatorTextField
                name={`givenName`}
                label="Vorname"
                autoComplete="given-name"
                validators={[
                  requiredValidator("Bitte geben Sie Ihren Vornamen an"),
                  { validator: minStringLength, params: [2], message: "Bitte kontrollieren Sie Ihre Eingabe" },
                ]}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6
              }}>
              <ValidatorTextField
                name={`familyName`}
                label="Nachname"
                autoComplete="family-name"
                validators={[
                  requiredValidator("Bitte geben Sie Ihren Nachnamen an"),
                  { validator: minStringLength, params: [2], message: "Bitte kontrollieren Sie Ihre Eingabe" },
                ]}
              />
            </Grid>
          </>
        )}
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: showPersonFields ? 6 : 4
          }}>
          <EmailCheck
            name="email"
            label="Ihre E-Mail-Adresse"
            autoComplete="email"
            emailErrorText={emailErrorText}
            setEmailErrorText={setEmailErrorText}
            validators={[requiredValidator("Bitte geben Sie Ihre E-Mail-Adresse an"), emailDefault]}
            redirectProps={null}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: showPersonFields ? 6 : 12,
            md: showPersonFields ? 6 : 4
          }}>
          <ValidatorTextField
            name="telephone"
            autoComplete={"tel"}
            label="Ihre Telefonnummer"
            validators={[requiredValidator("Bitte geben Sie Ihre Telefonnummer an"), ...isPhoneNumberDefault]}
          />
        </Grid>
        <Grid
          sx={dismissalCheckinStyle.buttonContainer}
          size={{
            xs: 12,
            sm: 6,
            md: 4
          }}>
          <ButtonLoading variant="contained" color="primary" sx={dismissalCheckinStyle.button} type="submit" fullWidth isLoading={isLoading}>
            Kostenlos prüfen lassen
          </ButtonLoading>
          <ButtonTextTermsOfServicePrivacy />
        </Grid>
      </Grid>
    </form>
  );
}
